import React, { Component } from 'react';
import './SolicitudesAprobadas.css';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSolicitudesAprobadas, clearErrors } from '../../../redux/actions/dataasistencialactions';

export class SolicitudesAprobadas extends Component {

  constructor() {
    super();
    this.state = {

      errors: {},
      open: false,
      opendelete: false,
      cotizacionid: ''
    };

  };

  componentDidMount() {
    this.props.getSolicitudesAprobadas();
  }
  render() {
    const { solicitudes, loadingdataasistencial } = this.props.dataAsistencial;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Link to={`/dashboard/solicitudesasistencial/solicitud/${params.row.solicitudid}`} style={{ textDecoration: 'none' }}>
            <MyButton tip="Ver Solicitud">
              <FaArrowCircleLeft color="#03178C" className="icon-formulario" />
            </MyButton>
          </Link>
        )
      },
      { field: 'titulo', headerName: 'Titulo', flex: 1, minWidth: 150 },
      { field: 'area', headerName: 'Area', flex: 1, minWidth: 150 },
      { field: 'servicio', headerName: 'Servicio', flex: 1, minWidth: 150 },
    ];


    let mapeosolicitudes = !loadingdataasistencial ? (
      <Box sx={{ height: 600, width: '100%', mt: 2 }}>
        <DataGrid
          rows={solicitudes || []}
          columns={columns}
          getRowId={(row) => row.solicitudid}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#1976d2',  // primary color
              color: '#ffffff',
              fontWeight: 'bold'
            },
            '& .MuiDataGrid-cell': {
              fontSize: '13px'
            }
          }}
        />
      </Box>


    ) : (<div className="div_cargando">
      <CircularProgress size={50} color="primary" className="login-progress" />
    </div>);


    return (
      <div>
        <div className="titulo_section">
          <div className="titulo_clientes">
            <h1 className="text-clientes">Mis Solicitudes de Compras Aprobadas</h1>
            <hr className="clientes_separator"></hr>

          </div>

          <div className="div_boton">
            <Link to={`/dashboard/solicitudesasistencial`}>
              <MyButton tip="Volver">
                <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
              </MyButton>
            </Link>
          </div>
        </div>


        <div className='table_container'>

          {mapeosolicitudes}

        </div>
      </div>
    )
  }
}

SolicitudesAprobadas.propTypes = {

  getSolicitudesAprobadas: PropTypes.func.isRequired,
  dataAsistencial: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,

};

const mapActionsToProps = { getSolicitudesAprobadas, clearErrors };

const mapStateToProps = (state) => ({
  dataAsistencial: state.dataAsistencial,
  UI: state.UI
})



export default connect(mapStateToProps, mapActionsToProps)(SolicitudesAprobadas);

